import type { Comment } from '@/tiptap/tiptap-extensions/custom/comments/types'
import { getFirstName } from '@/utils/user-name'

const ISSUE_PROVIDER_LABEL: Record<string, string> = {
  github: 'GitHub',
  githubissues: 'GitHub',
  github_issues: 'GitHub',
  jira: 'Jira',
  linear: 'Linear',
}

export function isIntegrationComment(comment: Comment) {
  return comment.source === 'INTEGRATION'
}

export function getIntegrationCommentAuthor(comment: Comment) {
  const provider = String(
    comment.externalProvider
      ?? comment.metadata?.externalProvider
      ?? comment.metadata?.provider
      ?? '',
  ).toLowerCase()
  const providerLabel = ISSUE_PROVIDER_LABEL[provider] ?? 'External'
  return `Synced from ${providerLabel} Issue`
}

export function getCommentAuthorLabel(
  comment: Comment,
  fallback = 'Unknown User',
) {
  if (isIntegrationComment(comment)) {
    return getIntegrationCommentAuthor(comment)
  }
  return getFirstName(comment.user?.name, fallback)
}
